module.exports = __webpack_public_path__ + "img/gbr.a9740682.svg";